import React from 'react';

export default function Footer() {
  return (
    <div className="copyright">
      &copy; App Brewing Company Ltd. All rights reserved. Design by <a href="https://html5up.net">HTML5 UP</a>.
    </div>
  );
}
